import { useMutation } from '@tanstack/react-query';
import { updateOtherSettings } from '@/lib/api/settings';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';

export const useOtherSettings = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: (data: { hide_store_referral_banner: boolean }) => updateOtherSettings(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending };
};
